module.exports = __webpack_public_path__ + "img/shipping.3358a286.svg";